import { StreamDataHandlers } from 'streamsState/StreamDataService';
import PortfolioReturnsDataMessage from 'communication/types/portfolioReturns/PortfolioReturnsDataMessage';
import PortfolioReturnsMessageBuffer from './PortfolioReturnsMessageBuffer';
import { WidgetType } from 'widgets/WidgetType';
import { getStreamHandlers } from 'widgets/store/stream/handlers';
import { Store } from 'redux';
import { LoggingService } from '@instinet-analytics/core-lib';
import { buildPortfolioReturnsStreamSlice } from 'widgets/portfolioReturns/store/stream/streamSlice';

const {
    actions: { createReceiveMessageBatchAction },
} = buildPortfolioReturnsStreamSlice();

export function buildPortfolioReturnsStreamHandlers(
    widgetKey: string,
    store: Store,
    loggingService: LoggingService
): StreamDataHandlers<PortfolioReturnsDataMessage> {
    const dispatch = store.dispatch;

    const messageBuffer = new PortfolioReturnsMessageBuffer(
        (streamKey: string, data: PortfolioReturnsDataMessage[]) => {
            dispatch(
                createReceiveMessageBatchAction(widgetKey, streamKey, data)
            );
        },

        loggingService
    );

    return {
        ...getStreamHandlers(dispatch, WidgetType.PORTFOLIO_RETURNS, widgetKey),
        onMessage: (streamKey: string, message: PortfolioReturnsDataMessage) =>
            messageBuffer.in(streamKey, [message]),
    };
}
